import Breadcrumbs from "@/components/feature/Breadcrumbs";
import SubmitForm from "@/pages/submit/components/SubmitForm";
import { processSteps } from "@/mocks/clueData";
import { useSeo } from "@/hooks/useSeo";

export default function SubmitPage() {
  useSeo({
    title: "匿名爆料投稿入口 - 17.cc网友爆料与线索征集",
    description:
      "17.cc匿名爆料投稿入口，支持用户投稿与线索征集。填写表单即可提交你的真实见闻，可选择匿名方式保护隐私。了解投稿方式与审核流程，让更多人看到你的故事。",
    keywords: "17.cc匿名爆料,17.cc投稿吃瓜,17.cc用户投稿,投稿入口,线索征集",
    path: "/submit",
    schema: [
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "匿名爆料投稿入口 - 17.cc 网友爆料站",
        description: "17.cc 匿名爆料与用户投稿入口，支持线索征集与隐私保护。",
        url: "https://17.cc/submit",
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "https://17.cc/" },
          { "@type": "ListItem", position: 2, name: "投稿爆料", item: "https://17.cc/submit" },
        ],
      },
    ],
  });

  return (
    <div className="mx-auto w-full px-4 py-8 md:px-8 md:py-12">
      <Breadcrumbs items={[{ label: "投稿爆料" }]} />

      <div className="mt-8 grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <header>
            <h1 className="font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              匿名爆料与投稿入口
            </h1>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base">
              感谢你愿意把经历讲出来。填写下面的表单即可提交线索，我们支持匿名爆料，
              会优先保护你的个人信息。请尽量把时间、地点与经过写清楚，这会让核实更顺利。
            </p>
          </header>
          <div className="mt-8">
            <SubmitForm />
          </div>
        </div>

        <aside className="lg:col-span-5">
          <div className="flex flex-col gap-6">
            <div className="rounded-lg border border-background-200 bg-background-100 p-6">
              <h2 className="font-heading text-base font-semibold text-foreground-950">投稿流程</h2>
              <ol className="mt-5 flex flex-col gap-5">
                {processSteps.map((step, index) => (
                  <li key={step.title} className="flex gap-4">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                      <i className={`${step.icon} text-lg`}></i>
                    </span>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950">
                        {index + 1}. {step.title}
                      </h3>
                      <p className="mt-1 text-sm leading-6 text-foreground-600">{step.desc}</p>
                    </div>
                  </li>
                ))}
              </ol>
            </div>

            <div className="rounded-lg border border-primary-200 bg-primary-50 p-6">
              <h2 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
                <i className="ri-shield-check-line text-lg text-primary-700"></i>
                投稿须知
              </h2>
              <ul className="mt-4 flex flex-col gap-3 text-sm leading-6 text-foreground-700">
                <li className="flex gap-2">
                  <i className="ri-check-line mt-1 text-primary-600"></i>
                  请确保内容真实，能提供可佐证的材料更有助于发布。
                </li>
                <li className="flex gap-2">
                  <i className="ri-check-line mt-1 text-primary-600"></i>
                  请勿填写他人姓名、电话、住址等隐私信息。
                </li>
                <li className="flex gap-2">
                  <i className="ri-check-line mt-1 text-primary-600"></i>
                  不接受商业推广、广告引流与人身攻击内容。
                </li>
                <li className="flex gap-2">
                  <i className="ri-check-line mt-1 text-primary-600"></i>
                  正文限 500 字，超出部分请分段提交或通过邮箱补充。
                </li>
              </ul>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
}